export const DUCK_VISIBILITY_KEY = "duck_visibility";

export const DUCK_SIDEBAR_DEFAULT_WIDTH = 450;
export const DUCK_SIDEBAR_MIN_WIDTH = 400;
export const DUCK_SIDEBAR_MAX_WIDTH = 800;
export const DUCK_CHAT_MAX_WIDTH = 975;
